import React from "react";
import PropTypes from "prop-types";
import classcat from "classcat";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { redirect } from "app/routes/Routes";
import CobeeSwitch from "app/components/CobeeSwitch";
import {
  translate as t,
  translate,
} from "infrastructure/translate/localization";

const RowOfEmployeeTable = ({
  employee,
  isBlocked,
  selectedItem,
  isSelected,
  toggleState,
  deleteItem,
}) => {
  const isRemoved = employee.state === "removed";
  const isMoved = employee.state === "moved";
  const linkToDetail = `employee-detail/${employee.id}?snapshot=${isMoved}`;
  const { inMigration } = employee;
  const benefitModelIsRemoved = !employee.benefitModelName;

  return (
    <tr
      className={classcat([
        { "no-border": employee.error || employee.warning },
      ])}
      disabled={isBlocked}
    >
      <td className="row-select">
        {!benefitModelIsRemoved && employee.state !== "moved" && (
          <div
            className="cob-checkbox"
            onClick={selectedItem}
            role="presentation"
          >
            {isSelected && <FontAwesomeIcon icon="check" />}
          </div>
        )}
      </td>

      <td>{employee.internalId}</td>

      <td className="cob-link primary">
        <span onClick={() => redirect(linkToDetail)} role="presentation">
          {employee.nameAndSurnames}
        </span>
      </td>

      <td style={benefitModelIsRemoved ? { color: "#aaa" } : {}}>
        {employee.benefitModelName || t("benefit-model-states.removed")}
      </td>

      <td style={isRemoved ? { color: "#aaa" } : {}}>
        {translate(`employee-states.${employee.state}`)}
      </td>

      <td className="center-content">
        {!isRemoved && !isMoved && !inMigration && (
          <CobeeSwitch onChange={toggleState} checked={!isBlocked} />
        )}
      </td>

      <td className="center-content cob-link">
        <p className="mayus">
          <span onClick={() => redirect(linkToDetail)} role="presentation">
            {t("actions.detail")}
          </span>
        </p>
      </td>

      <td className="center-content cob-link left trash">
        {!isRemoved && !isMoved && !inMigration && (
          <FontAwesomeIcon icon="trash" alt="delete" onClick={deleteItem} />
        )}
      </td>
    </tr>
  );
};

RowOfEmployeeTable.propTypes = {
  employee: PropTypes.object.isRequired,
  isBlocked: PropTypes.bool.isRequired,
  selectedItem: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  toggleState: PropTypes.func.isRequired,
  deleteItem: PropTypes.func.isRequired,
};

export default RowOfEmployeeTable;
